import { createGlobalStyle } from 'styled-components';
import 'typeface-muli';
import {flexUnit} from './mixins.js';

const GlobalStyles = createGlobalStyle`

    html, body {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }

    body {
        font-family: 'Muli', sans-serif;
        background-color: white;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
    }   
  
    a {
        text-decoration: none;
    }
    section{
        position: relative;
        height: auto;
    }
    * {
        box-sizing: border-box;
        margin:0;
        padding:0;
        font-family: aktiv-grotesk, sans-serif;
    }
    #root{
        position: relative;
        top: 0;
        height: 100%;
    }
    
    @media screen and (max-width: 1024px){
        .cursor{
            display: none;
        }
    }
    .grey-400{
        color: #A2A19D;
    }
    .grey-700{
        color: #585653;
    }
    .primary-green{
        color: #45B865;
    }
    .green-secondary {
        color:  ${ props => props.theme.colors.green_secondary};
    }
    .cta--primary{
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }
    @media screen and (max-width: 1023px){
        .cta--primary{
            padding: 12px 0
        }
    }
    @media screen and (max-width: 767px){
        .cta--primary{
            padding: 14px 0
        }
    }
    .cta--primary img.prev, .cta--primary svg.prev{
        margin-right: 16px;
    }
    .cta--primary img.next, .cta--primary svg.next{
        margin-left: 16px;
    }
    h1.big--title{
        ${flexUnit(5, 35, 54, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h2.big--title{
        ${flexUnit(19, 60, 260, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h2.md--title{
        ${flexUnit(16, 55, 210, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h3.big--title{
        ${flexUnit(11.5, 48, 167, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h3.md--title{
        ${flexUnit(9.33, 48, 134, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h4.big--title{
        ${flexUnit(8, 43, 85, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h4.md--title{
        ${flexUnit(7, 43, 68, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h5.big--title{
        ${flexUnit(5, 35, 54, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h6.big--title{
        ${flexUnit(4, 28, 43, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    h6.md--title{
        ${flexUnit(4, 28, 43, 'vw', 'font-size')};
        line-height: 110%;
        letter-spacing: -.05em;
        font-family: 'Alliance No.2', sans-serif;
        font-weight: 400;
    }
    p.base{
        font-size: 18px;
        line-height: 110%;
        font-family: aktiv-grotesk, sans-serif;
        font-weight: 400;
        font-style: normal;
    }
    p.rounded--cta-text{
        font-size: 14px;
        line-height: 110%;
        font-family: aktiv-grotesk, sans-serif;
        font-weight: 400;
        font-style: normal;
    }
    p.preset-9{
        font-size: 35px;
    }
    p.preset-10{
        font-size: 28.13px;
    }
    p.preset-11{
        font-size: 22.5px;
    }
    p.preset-12{
        font-size: 18px;
    }
    p.preset-13{
        font-size: 14.4px;
    }
    @media screen and (max-width: 1023px){
        p.base{
            font-size: 16px;
        }
        p.preset-9{
            font-size: 28px;
        }
        p.preset-10{
            font-size: 22.5px;
        }
        p.preset-11{
            font-size: 18px;
        }
        p.preset-12{
            font-size: 16px;
        }
        p.preset-13{
            font-size: 12.8px;
        }
    }
    @media screen and (max-width: 767px){
        p.base{
            font-size: 14.4px;
        }
        p.preset-9{
            font-size: 22.5px;
        }
        p.preset-10{
            font-size: 18px;
        }
        p.preset-11{
            font-size: 14.4px;
        }
        p.preset-12{
            font-size: 14px;
        }
        p.rounded--cta-text{
            font-size: 12.8px;
        }
    }
    .ak-gr-r {
        font-family: aktiv-grotesk, sans-serif;
        font-weight: 400;
        font-style: normal;
    }
    .ak-gr-m {
        font-family: aktiv-grotesk, sans-serif;
        font-weight: 500;
        font-style: normal;
    }
    .rounded--cta{
        padding: 12px 24px 15px 24px;
        border-radius: 22px;
        font-size: 14px;
        text-align: center;
        border: 1px solid #000;
        color: #000;
        background-color: transparent;
        cursor: pointer;
        transition: background-color .25s ease-out, color .2s ease-out .05s;
        &.full-color {
            padding: 18px 48px 18px 48px;
            background-color: #426d74;
            border-color: #426d74;
            border-radius: 36px;
            color: #fff;
            font-size: 24px;
            display: inline-block;
            margin: 40px auto;
        }
        &.center-cta{
            padding: 18px 48px 18px 48px;
            border-radius: 36px;
            font-size: 24px;
            display: inline-block;
            margin: 40px auto 0;
            background-color: ${ props => props.theme.colors.green_secondary};
            border-color: ${ props => props.theme.colors.green_secondary};
            color: #fff;
            a {
                color: inherit;
                text-decoration: none;
            }
            @media screen and (max-width: 767px){
                width: 100%;
            }
        }
    }
    .rounded--cta:hover{
        background-color: ${ props => props.theme.colors.green_secondary};
        border-color: ${ props => props.theme.colors.green_secondary};
        color: #fff;
        &.full-color {
            background-color: #fff;
            color: #426d74;
            border-color: #426d74;
        }
        &.center-cta{
            color: #000;
            background-color: #fff;
        }
        
    }
    .cta--fixed{
        position: fixed;
        bottom: 50px;
        right: 20px;
        z-index: 3;
        font-size: 24px;
        background-color: ${ props => props.theme.colors.green_secondary};
        border-color: ${ props => props.theme.colors.green_secondary};
        color: #fff;
        @media screen and (max-width: 767px){
            font-size: 20px;
        }
    }
    .cta--blink {
        animation: blinkAnimation 5s ease-in-out infinite;
    }

    @keyframes blinkAnimation {
        0% {
            opacity: 1;
        }
        8% {
            opacity: 0;
        }
        16% {
            opacity: 1;
        }
        24% {
            opacity: 0;
        }
        32% {
            opacity: 1;
        }
        100% {
            opacity: 1;
        }
    }
    .hide-desktop,.hide-tablet,.hide-mobile {}
    .show-mobile{
        display: none !important;
    }
    @media screen and (min-width: 1024px){
        .hide-desktop {
            display: none !important;
        }
    }
    @media screen and (max-width: 1023px){
        .hide-tablet {
            display: none !important;
        }
    }
    @media screen and (max-width: 767px){
        .hide-mobile {
            display: none !important;
        }
        .show-mobile{
            display: block !important;
        }
    }
    
    .viewport {
        overflow: hidden;
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .paragraph--col-wrap{
        position: relative;
        padding: 0 64px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }
    .paragraph--col-big{
        flex: 0 0 66.66%;
        max-width: 66.66%;
    }
    .paragraph--col-small{
        flex: 0 0 33.33%;
        max-width: 33.33%;
    }
    @media screen and (max-width: 1023px){
        .paragraph--col-wrap{
            padding: 0 40px;
        }
    }
    @media screen and (max-width: 767px){
        .paragraph--col-wrap{
            padding: 0 24px;
            flex-direction: column;
        }
        .paragraph--col-big{
            flex: 0 0 100%;
            max-width: 100%;
        }
        .paragraph--col-small{
            flex: 0 0 100%;
            max-width: 100%;
        }
    }

    .column--quote-wrap{
        padding: 0 64px;
        margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
        text-align: center;
        &.medium-margin {
            margin-bottom: ${props => props.theme.components_spacing_desk.large}px;
        }
    }
    .column--quote-wrap p, .column--quote-wrap h6{
        max-width: 66.66%;
        margin: 0 auto;
    }
    .column--quote-wrap p{
        margin-bottom: 24px;
    }
    .side--quote-wrap{
        position: relative;
        padding: 0 64px;
        margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
        text-align: center;
        display: flex;
        justify-content: space-between;
        text-align: left;
        &.no-margin-btm {
            margin-bottom: 80px;
        }
    }
    .side--quote-wrap.extra--margin{
        margin-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
    }
    .side--quote-wrap .side--title{
        position: relative;
        flex: 0 0 33.33%;
        max-width: 33.33%;
    }
    .side--quote-wrap img{
        margin-left: 0;
        margin-top: 40px;
        max-width: 50%;
        display: block;
    }
    .side--quote-wrap img.avatar-img{
        margin-left: 0;
        margin-bottom: 40px;
        margin-top: 0;
        max-width: 70%;
        display: block;
    }
    .side--quote-wrap .side--text{
        flex: 0 0 58.33%;
        max-width: 58.33%;
        color: ${ props => props.theme.colors.grey_700};
    }
    .side--quote-wrap .side--text .full {
        width: 100%;
        display: block;
        max-width: 100%;
        margin: 0 auto;
        @media screen and (max-width: 767px){
            margin-top: 40px;
        }
    }
    .side--quote-wrap .side--text .intro-img{
        width: auto;
        display: inline-block;
        max-width: 40%;
        margin: 20px 20px 40px 0;
        @media screen and (max-width: 767px){
            margin-top: 40px;
        }
    }
    .side--quote-wrap .side--text ul {
        margin: 40px 0;
        padding-left:1em;
    }
    .side--quote-wrap .side--text ul li{
        margin: 24px 0;
        padding-left:1em;
    }
    .side--quote-wrap .side--text a.apply-wrap {
        color: ${ props => props.theme.colors.green_secondary};
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    .side--quote-wrap .side--text a.apply-wrap img {
        margin: 0 0 0 10px;
    }
    .center--paragraph{
        position: relative;
        max-width: 66.66%;
        text-align: center;
        padding: 0 64px;
        margin: 0 auto ${props => props.theme.components_spacing_desk.medium}px;
    }
    .center--paragraph .intro-title{
        margin-bottom: 24px;
    }
    .center--paragraph .quote-icon {
        margin: 0 auto 32px;
    }
    .center--paragraph .quote-author{
        margin: 32px auto 0;
    }
    .under--hero{
        text-align: center;
        max-width: 50%;
        margin: ${props => props.theme.components_spacing_desk.xlarge}px  auto ${props => props.theme.components_spacing_desk.xlarge}px;
    }
    .banner--config-shirt {
        position: relative;
        width: auto;
        padding: 0 64px 80px;
        .banner--config-shirt-wrapper{
            position: relative;
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }
        img {
            flex: 1 1 33.33%;
            max-width: 33.33%;
        }
        .banner--config-text{
            flex: 1 1 58.33%;
            max-width: 58.33%;
            color: #585653;
        }
        @media screen and (max-width: 1439px){
            padding: 0 40px 80px;
        }
        @media screen and (max-width: 1023px){
            padding: 0 24px 64px;
            .banner--config-shirt-wrapper{
                flex-direction: column;
            }
            img {
                flex: 1 1 100%;
                max-width: 100%;
                width: 100%;
                margin-bottom: 40px;
            }
            .banner--config-text{
                flex: 1 1 100%;
                max-width: 100%;
                color: #585653;
            }
        }
    }
    .shelfzone--quotes {
        background-color: #F2F2F2;
        padding-bottom: ${props => props.theme.components_spacing_desk.medium}px;
        margin-bottom: ${props => props.theme.components_spacing_desk.large}px;
        .title-section {
            padding: ${props => props.theme.components_spacing_desk.large}px 64px;
        }
    }
    .download-holder {
        text-align: center;
        margin-bottom:${props => props.theme.components_spacing_desk.large}px;
    }
    .close-back{
        position: absolute;
        top: 180px;
        right: 50px;
        width: 44px;
        height: 44px;
        z-index: 5;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
            display: block;
            width: 100%;
        }
    }
    @media screen and (max-width: 1439px){
        .column--quote-wrap p, .column--quote-wrap h6{
            max-width: 83.33%;
        }
        .side--quote-wrap{
            padding: 0 40px;
            margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
            &.no-margin-btm {
                margin-bottom: 80px;
            }
        }
        .shelfzone--quotes {
            background-color: #F2F2F2;
            .title-section {
                padding: ${props => props.theme.components_spacing_desk.large}px 40px;
            }
        }
    }
    @media screen and (max-width: 1023px){
        .column--quote-wrap, .side--quote-wrap{
            padding: 0 40px;
            margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
            &.no-margin-btm {
                margin-bottom: 40px;
            }
            &.medium-margin {
                margin-bottom: ${props => props.theme.components_spacing_tablet.large}px;
            }
        }
        .close-back{
            top: 100px;
        }
        .shelfzone--quotes {
            padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
            margin-bottom: ${props => props.theme.components_spacing_tablet.large}px;
            .title-section {
                padding: ${props => props.theme.components_spacing_tablet.large}px 40px;
            }
        }
        .download-holder {
            text-align: center;
            margin-bottom:${props => props.theme.components_spacing_tablet.large}px;
        }
        .side--quote-wrap.extra--margin{
            margin-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
        }
        .side--quote-wrap .side--title{
            flex: 0 0 33.33%;
            max-width: 33.33%;
        }
        .side--quote-wrap .side--text{
            flex: 0 0 66.66%;
            max-width: 66.66%;
        }
        .side--quote-wrap-tablet {
            flex-direction: column;
            .side--title, .side--text {
                flex: 0 0 100%;
                max-width: 100%;
                margin-bottom: 40px;
            }
        }
        .center--paragraph{
            max-width: 83.33%;
            text-align: center;
            padding: 0 40px;
            margin: 0 auto ${props => props.theme.components_spacing_tablet.medium}px;
        }
        .center--paragraph .intro-title{
            margin-bottom: 16px;
        }
        .center--paragraph .quote-icon {
            margin: 0 auto 24px;
            width: 30px;
        }
        .center--paragraph .quote-author{
            margin: 24px auto 0;
        }
        .under--hero{
            text-align: center;
            max-width: 66.66%;
            margin: ${props => props.theme.components_spacing_tablet.xlarge}px  auto ${props => props.theme.components_spacing_tablet.xlarge}px;
        }
    }
    @media screen and (max-width: 767px){
        .column--quote-wrap p, .column--quote-wrap h6{
            max-width: 100%
        }
        .column--quote-wrap, .side--quote-wrap{
            padding: 0 24px;
            margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
            &.no-margin-btm {
                margin-bottom: 40px;
            }
            &.medium-margin {
                margin-bottom: ${props => props.theme.components_spacing_mobile.large}px;
            }
        }
        .shelfzone--quotes {
            padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
            margin-bottom: ${props => props.theme.components_spacing_mobile.large}px;
            .title-section {
                padding: ${props => props.theme.components_spacing_mobile.large}px 24px;
            }
        }
        .download-holder {
            text-align: center;
            margin-bottom:${props => props.theme.components_spacing_mobile.large}px;
        }
        .side--quote-wrap.extra--margin{
            margin-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
        }
        .side--quote-wrap{
            flex-direction: column;
        }
        .side--quote-wrap .side--title{
            max-width: 100%;
            margin-bottom: 16px;
        }
        .side--quote-wrap .side--title.side--title-adv {
            margin-bottom: 40px;
        }
        .side--quote-wrap img.avatar-img{
            max-width: 100%;
            width: 100%;
            margin-bottom: 20px;
        }
        .side--quote-wrap img{
            margin-left: 0;
            margin-top: 16px;
        }
        .side--quote-wrap .side--text{
            max-width: 100%;
        }
        .side--quote-wrap .side--text ul {
            margin: 24px 0;
            padding-left:1em;
        }
        .side--quote-wrap .side--text ul li{
            margin: 16px 0;
            padding-left:1em;
        }
        .center--paragraph{
            max-width: 100%;
            text-align: center;
            padding: 0 24px;
            margin: 0 auto ${props => props.theme.components_spacing_mobile.medium}px;
        }
        .under--hero{
            text-align: center;
            max-width: 100%;
            padding: 0 24px;
            margin: ${props => props.theme.components_spacing_mobile.xlarge}px  auto ${props => props.theme.components_spacing_mobile.xlarge}px;
        }
    }
`;

export default GlobalStyles;
